<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Listagem de RDT (Resumo de Declaração Tributária).</span>
                <br />
                <span class="navigation">Emissão > Resumo de Declaração Tributária</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div>
            <label style="font-weight: bold; font-size: 12px">Filtro Pesquisa:</label>
            <div class="row">
              <div class="col-md-4 col-lg-2 mb-3">
                <span class="p-fluid">
                  <CustomCalendar id="dataIni" name="dataFim" v-model="dataIni" :showIcon="true" dateFormat="dd/mm/yy"
                    placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
                </span>
              </div>
              <div class="col-md-4 col-lg-2 mb-3">
                <span class="p-fluid">
                  <CustomCalendar id="dataFim" name="dataFim" v-model="dataFim" :showIcon="true" dateFormat="dd/mm/yy"
                    placeholder="Data Final" v-maska="'##/##/####'" />
                </span>
              </div>
              <div class="col-md-4 col-lg-4 mb-3" v-if="this.currentUser.usuario.idBolAdmin">
                <span class="p-fluid">
                  <InputText type="text" id="filtro" v-model="filtro"
                    placeholder="Filtro Por Documento ou Nome do Contribuinte" autocomplete="off" />
                </span>
              </div>
              <div class="col-md-4 col-lg-1">
                <Button @click="pesquisar()" alt="Pesquisar" label="Pesquisar" type="button"
                  class="p-button-primary mr-2" icon="pi pi-search" :disabled="loading" />

              </div>
            </div>
          </div>

          <hr />

          <div class="row pr-3 pl-3">
            <h4 class="panel-title">
              <span class="title">RDTs Gerados no Período.</span>
            </h4>
            <DataTable :value="listRdt" :paginator="true" :rows="10" class="p-datatable-responsive" :key="0"
              :autoLayout="true" style="min-width: 100%" ref="dt" :filters="filtersModel">
              <Column headerStyle="width: 1%">
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                      data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">

                      <button class="dropdown-item" type="button" :disabled="loading"
                        @click="impressaoConsultaRdt(slotProps.data.id)">
                        <span class="pi pi-print mr-2"></span>Impressão RDT
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        @click="openImpressaoBoleto(slotProps.data.id)"
                        v-if="slotProps.data.situacaoCalculo === 'Débito'">
                        <span class="pi pi-print mr-2"></span>Imprimir Boleto
                      </button>

                      <button class="dropdown-item" type="button" :disabled="loading"
                        @click="openDialogDeclaracoesRdt(slotProps.data.id, slotProps.data.numeroRdt, slotProps.data.origem)">
                        <span class="pi pi-file-o mr-2"></span>Consultar Declarações de Origem
                      </button>

                      <button class="dropdown-item" type="button" :disabled="loading"
                        @click="openDialogProtocoloRdt(slotProps.data.id, slotProps.data.numeroRdt)"
                        v-if="currentUser && currentUser.usuario && currentUser.usuario.idBolAdmin">
                        <span class="pi pi-file-o mr-2"></span>Consultar Protocolo
                      </button>

                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="currentUser && currentUser.usuario && currentUser.usuario.idBolAdmin && slotProps.data.situacaoCalculo === 'Débito'"
                        @click="openDialogEditarRdt(slotProps.data.id, slotProps.data.numeroRdt)">
                        <span class="pi pi-pencil mr-2"></span>Editar
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="currentUser && currentUser.usuario && currentUser.usuario.idBolAdmin && slotProps.data.situacaoCalculo === 'Débito'"
                        @click="openDialogCancelarRdt(slotProps.data.id, slotProps.data.numeroRdt)">
                        <span class="pi pi-times mr-2"></span>Cancelar
                      </button>


                    </div>
                  </div>
                </template>
              </Column>
              <Column headerStyle="width: 5%" field="numeroRdt" header="Número RDT">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.numeroRdt }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['numeroRdt']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 3%" field="tipo" header="Tipo" bodyStyle="text-align: center">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.tipo }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['tipo']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 3%" field="competencia" header="Competência">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.competencia }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['competencia']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>
              <Column headerStyle="width: 10%" field="contribuinte" header="Contribuinte" :filterMatchMode="'contains'">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.contribuinte }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['contribuinte']" class="p-column-filter"
                    placeholder="Contém" style="width: 5em" />
                </template>
              </Column>

              <Column headerStyle="width: 10%" field="valorIss" header="Valor">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.valorIssFormatado }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['valorIss']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>

              <Column headerStyle="width: 10%" field="situacao" header="Situação">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.situacao }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['situacao']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>

              <Column headerStyle="width: 10%" field="situacaoCalculo" header="Situação DAM">
                <template #body="slotProps">
                  <div>
                    {{ slotProps.data.situacaoCalculo }}
                  </div>
                </template>
                <template #filter>
                  <InputText type="text" v-model="filtersModel['situacaoCalculo']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 5em" />
                </template>
              </Column>

              <template #footer>
                <div style="text-align: right">
                  <Button icon="pi pi-external-link" label="Exportar para CSV" @click="exportCSV($event)" />
                </div>
              </template>
            </DataTable>
          </div>
          <hr />
          <template>
            <Button @click="openDialogRdt()" label="Gerar RDT Manual" type="button"
              v-if="this.currentUser.usuario.idBolAdmin" class="p-button-primary mr-2 p-button-success"
              icon="pi pi-check" :disabled="loading" />
          </template>
        </div>
      </div>
    </div>
    <Dialog header="Confirmar Processo de Geração de RDT" :visible.sync="openRdt" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Competência:
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="openRdt = false" />
      </h1><br />
      <span class="p-fluid">
        <InputMask id="competencia" type="text" placeholder="Competência" autocomplete="off" v-model="competencia"
          mask="9999/99" class="inputLogin" />
      </span>
      <hr />
      <div class="botoes-avancar-voltar">
        <Button label="Gerar" icon="pi pi-check" @click="gerar()" :disabled="loading" />
        <Button label="Fechar" icon="pi pi-times" @click="openRdt = false" class="p-button-danger" />
      </div>
    </Dialog>
    <Dialog :visible.sync="showDeclaracoes" :modal="true" :closable="false">
      <h1 class="titulo-header">
        Declarações relacionadas ao RDT
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showDeclaracoes = false" />
      </h1><br />
      <div class="scrolable-dialog">
        <div id="topo" class="row">
          <DataTable :value="declaracoesList" :paginator="true" :rows="10" class="p-datatable-responsive"
            :autoLayout="true">
            <Column headerStyle="width: 1%">
              <template #body="slotProps">
                <div class="dropdown">
                  <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                    data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <button class="dropdown-item" type="button" :disabled="loading"
                      @click="impressaoRdt(slotProps.data.id, numeroRdtSelecionado, tipoDeclaracaoSelecionado)">
                      <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Impressão
                    </button>
                  </div>
                </div>
              </template>
            </Column>
            <Column field="tipoDeclaracao" header="Tipo Declaração"></Column>
            <Column field="numero" header="Número"></Column>
            <Column field="competenciaFormatada" header="Competência"></Column>
            <Column field="status" header="Status"></Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div class="container">
        <div class="row">
          <div>
            <Button @click="showDeclaracoes = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showNotasRdt" :modal="true" :closable="false">
      <h1 class="titulo-header">
        Editar Notas Fiscais relacionadas ao RDT: {{ numeroRdtSelecionado }}
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showNotasRdt = false" />
      </h1><br />
      <div class="scrolable-dialog">
        <div id="topo" class="row">
          <h4 class="panel-title">
            <span class="title" style="color:red">Selecione abaixo as notas que deseja remover do RDT.</span>
          </h4>
          <DataTable :value="notasRdList" :paginator="true" :rows="10" class="p-datatable-responsive" :autoLayout="true"
            ref="dtEdicao" :filters="filtersEdicaoNotaModel" :style="{ width: '60vw' }"
            :contentStyle="{ overflow: 'visible' }">
            <Column headerStyle="width: 3%" field="selecionado" header>
              <template #body="slotProps">
                <Checkbox v-model="slotProps.data.selecionado" :binary="true" />
              </template>
            </Column>
            <Column headerStyle="width: 1%">
              <template #body="slotProps">
                <div class="dropdown">
                  <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                    data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <button class="dropdown-item" type="button" :disabled="loading"
                      @click="impressaoNota(slotProps.data)">
                      <span class="pi pi-print mr-2"></span>Imprimir
                    </button>
                  </div>
                </div>
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="tipo" header="Tipo">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.tipo }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersEdicaoNotaModel['tipo']" class="p-column-filter"
                  placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="numero" header="Número">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.numero }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersEdicaoNotaModel['numero']" class="p-column-filter"
                  placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="dataFatoGeradorFormatada" header="Fato Gerador">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.dataFatoGeradorFormatada }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersEdicaoNotaModel['dataFatoGeradorFormatada']"
                  class="p-column-filter" placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="valorBaseCalculo" header="Base de Cálculo">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.valorBaseCalculoFormatado }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersEdicaoNotaModel['valorBaseCalculo']" class="p-column-filter"
                  placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="valorIss" header="Valor ISS">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.valorIssFormatado }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersEdicaoNotaModel['valorIss']" class="p-column-filter"
                  placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div>
        <div class="row">
          <div class="col-md-2 mb-2">
            <label for="protocolo">Número de Protocolo:*</label>
            <span class="p-fluid">
              <InputText type="text" id="protocolo" v-model="protocolo" autocomplete="off" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="obs">Observação:*</label>
            <span class="p-fluid">
              <textarea id="descServico" name="obs" v-model="observacao" rows="5" style="width: 100%" />
            </span>
          </div>
        </div>
        <div class="row">
          <div>
            <Button @click="editarRdt()" type="button" label="Registrar" class="p-button-primary mr-2"
              icon="pi pi-check" />
          </div>
          <div>
            <Button @click="showNotasRdt = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showCancelarRdt" :modal="true" :closable="false" :style="{ width: '60vw' }">
      <h1 class="titulo-header">
        Confirma o Cancelamento do RDT: {{ numeroRdtSelecionado }}?, ao cancelar o RDT, as declarações relacionadas, serão reativadas! 
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showCancelarRdt = false" />
      </h1><br />
      <hr />

      <div>
        <div class="row">
          <div class="col-md-2 mb-2">
            <label for="protoCancelamento">Número de Protocolo:*</label>
            <span class="p-fluid">
              <InputText type="text" id="protoCancelamento" v-model="protocolo" autocomplete="off" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="obsCancelamento">Observação:*</label>
            <span class="p-fluid">
              <textarea id="obsCancelamento" name="obsCancelamento" v-model="observacao" rows="5" style="width: 100%" />
            </span>
          </div>
        </div>
        <div class="row">
          <div>
            <Button @click="cancelarRdt()" type="button" label="Cancelar" class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-check" />
          </div>
          <div>
            <Button @click="showCancelarRdt = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showProtocoloEdicao" :modal="true" :closable="false">
      <h1 class="titulo-header">
        Protocolo de {{ (notasProtocoloRdList && notasProtocoloRdList.length > 0) ? 'Edição' : 'Cancelamento' }} do RDT: {{ numeroRdtSelecionado }}
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showProtocoloEdicao = false" />
      </h1><br />
      <div class="scrolable-dialog" v-if="this.protocoloSelecionado && this.protocoloSelecionado.id">
        <div class="row">
          <div class="col-md-2 mb-2">
            <label for="protocolo">Número de Protocolo:*</label>
            <span class="p-fluid">
              <InputText type="text" id="protocolo" v-model="this.protocoloSelecionado.numeroProtocolo"
                disabled="true" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mb-2">
            <label for="obs">Observação:*</label>
            <span class="p-fluid">
              <textarea id="descServico" name="obs" v-model="this.protocoloSelecionado.observacao" rows="5"
                style="width: 100%" disabled="true" />
            </span>
          </div>
        </div>
        <div class="row" v-if="(notasProtocoloRdList && notasProtocoloRdList.length > 0)">
          <h4 class="panel-title">
            <span class="title" style="color:red">Notas removidas do RDT.</span>
          </h4>
          <DataTable :value="notasProtocoloRdList" :paginator="true" :rows="10" class="p-datatable-responsive"
            :autoLayout="true" ref="dtNotasProtocolo" :filters="filtersNotasProtocoloModel" :style="{ width: '60vw' }"
            :contentStyle="{ overflow: 'visible' }">
            <Column headerStyle="width: 1%">
              <template #body="slotProps">
                <div class="dropdown">
                  <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                    data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <button class="dropdown-item" type="button" :disabled="loading"
                      @click="impressaoNota(slotProps.data)">
                      <span class="pi pi-print mr-2"></span>Imprimir
                    </button>
                  </div>
                </div>
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="tipo" header="Tipo">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.tipo }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersNotasProtocoloModel['tipo']" class="p-column-filter"
                  placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="numero" header="Número">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.numero }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersNotasProtocoloModel['numero']" class="p-column-filter"
                  placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="dataFatoGeradorFormatada" header="Fato Gerador">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.dataFatoGeradorFormatada }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersNotasProtocoloModel['dataFatoGeradorFormatada']"
                  class="p-column-filter" placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="valorBaseCalculo" header="Base de Cálculo">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.valorBaseCalculoFormatado }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersNotasProtocoloModel['valorBaseCalculo']" class="p-column-filter"
                  placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
            <Column headerStyle="width: 5%" field="valorIss" header="Valor ISS">
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.valorIssFormatado }}
                </div>
              </template>
              <template #filter>
                <InputText type="text" v-model="filtersNotasProtocoloModel['valorIss']" class="p-column-filter"
                  placeholder="Iniciando com" style="width: 5em" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <hr />

      <div>
        <div class="row">
          <div>
            <Button @click="showProtocoloEdicao = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Imprimir Boleto" :visible.sync="showBoleto" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Imprimir Boleto?
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showBoleto = false" />
      </h1><br />
      <div class="col-md-8 mb-8">
        <label for="dataVencBoleto">Data de Vencimento: *</label>
        <span class="p-fluid">
          <Calendar id="dataVencBoleto" name="dataVencBoleto" v-model="dataVencimento" :showIcon="true"
            dateFormat="dd/mm/yy" @date-select="vencimentoSelect()" />
        </span>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="imprimirBoleto()" :disabled="loading" class="mr-2"
              v-if="idCalculoParcelado" />

            <Button label="Não" icon="pi pi-times" @click="showBoleto = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>


  </div>
</template>
<script>
import RdtGerenciador from '../services/nfse/rdt.gerenciador.service';
import LoginService from '../services/acesso/login.service'
import ReportService from "../services/report.service";
import GpiService from "../services/nfse/gpi.service";
import CustomCalendar from "../components/global/CustomCalendar.vue";

export default {
  name: 'rdtGerenciar',
  components: { CustomCalendar },

  data() {
    return {
      loading: false,
      listRdt: [],
      idRdtSelecionado: null,
      numeroRdtSelecionado: null,
      tipoDeclaracaoSelecionado: null,
      filtro: null,
      filtersModel: {},
      filtersEdicaoNotaModel: {},
      filtersNotasProtocoloModel: {},
      filters: {},
      currentUser: null,
      openRdt: false,
      dataIni: null,
      dataFim: null,
      competencia: null,
      showDeclaracoes: false,
      showNotasRdt: false,
      showCancelarRdt: false,
      declaracoesList: [],
      notasRdList: [],
      notasProtocoloRdList: [],
      protocoloSelecionado: null,
      showProtocoloEdicao: false,
      showBoleto: false,
      dataVencimento: null,
      idCalculoOrigem: null,
      idCalculoParcelado: null,
      protocolo: null,
      observacao: null,
    };
  },

  created() {

    this.currentUser = LoginService.currentUserValue;
    this.openRdt = false;
    this.dataFim = new Date();
    this.dataFim.setDate(this.dataFim.getDate() - 30);
    this.dataIni = new Date();
    this.dataIni.setDate(this.dataIni.getDate() - 90);
    this.pesquisar();
  },

  methods: {
    pesquisar() {
      this.processando(true);

      RdtGerenciador.findAllPorPeriodo(
        this.currentUser.usuario.idCliente,
        (this.currentUser.usuario.idBolAdmin ? null : this.currentUser.contribuinte.idContribuinte),
        this.filtro,
        this.dataIni,
        this.dataFim,
      )
        .then((response) => {
          this.listRdt = response ? response.data : [];
        })
        .then(() => {
          this.processando(false);
        });

    },
    openDialogRdt() {
      this.openRdt = true;
      this.competencia = null;
    },
    gerar() {
      this.filtro = '';
      this.processando(true);
      const partes = this.competencia.split("/");

      const ano = parseInt(partes[0], 10);
      const mes = parseInt(partes[1], 10);

      const atual = new Date();
      const anoAtual = atual.getFullYear();
      const mesAtual = atual.getMonth();

      if(ano < anoAtual){
        this.processando(false);
        this.$root.$emit(
          "alert:warn",
          "A competência não pode ser de um ano anterior."
        );
        return;
      }
      if(ano > anoAtual || (ano === anoAtual && mes > mesAtual)){
        this.processando(false);
        this.$root.$emit(
          "alert:warn",
          "A competência não pode ser uma data futura."
        );
        return;
      }

      RdtGerenciador.gerar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        ano,
        mes
      )
        .then((response) => {
          console.log(response);
          this.$toast.add({
            severity: "success",
            summary: "RDT Gerado com Sucesso! "
          });
        },
          (error) => {
            this.$root.$emit(
              "alert:error",
              error.response.data
            );
          })
        .then(() => {
          this.processando(false);
        });

    },
    editarRdt() {
      if (!this.protocolo) {
        this.$root.$emit(
          "alert:warn",
          'Obrigatório informar o campo número de protocolo!'
        );
        return;
      }
      if (!this.observacao) {
        this.$root.$emit(
          "alert:warn",
          'Obrigatório informar o campo observação!'
        );
        return;
      }
      let checked = false;
      this.notasRdList.forEach(function (value) {
        if (value.selecionado) {
          checked = true;
          return;
        }
      });
      if (!checked) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos uma nota para realizar a Edição do RDT!"
        );
        return;
      }

      RdtGerenciador.editar(
        this.idRdtSelecionado,
        this.currentUser.usuario.idUsuario,
        this.protocolo,
        this.observacao,
        this.notasRdList
      )
        .then((response) => {
          console.log(response);
          this.$toast.add({
            severity: "success",
            summary: "RDT Editado com Sucesso! "
          });
          this.pesquisar();
        },
          (error) => {
            this.$root.$emit(
              "alert:error",
              error.response.data
            );
          })
        .then(() => {
          this.processando(false);
        });
    },
    cancelarRdt() {
      if (!this.protocolo) {
        this.$root.$emit(
          "alert:warn",
          'Obrigatório informar o campo número de protocolo!'
        );
        return;
      }
      if (!this.observacao) {
        this.$root.$emit(
          "alert:warn",
          'Obrigatório informar o campo observação!'
        );
        return;
      }
      
      const cancelamento = {
        idRdt: this.idRdtSelecionado,
        idUsuario: this.currentUser.usuario.idUsuario,
        protocolo: this.protocolo,
        observacao: this.observacao
      };

      RdtGerenciador.cancelar(
        cancelamento
      )
        .then((response) => {
          console.log(response);
          this.$toast.add({
            severity: "success",
            summary: "RDT Cancelado com Sucesso! "
          });
          this.pesquisar();
        },
          (error) => {
            this.$root.$emit(
              "alert:error",
              error.response.data
            );
          })
        .then(() => {
          this.processando(false);
          this.showCancelarRdt = false;
        });
    },
    async openDialogDeclaracoesRdt(idRdt, numeroRdt, origem) {
      this.numeroRdtSelecionado = numeroRdt;
      this.tipoDeclaracaoSelecionado = (origem === '1' ? 'N' : 'S');
      await this.consultaDeclaracoes(idRdt);
    },

    async openDialogEditarRdt(idRdt, numeroRdt) {
      this.idRdtSelecionado = idRdt;
      this.protocolo = null;
      this.observacao = null;
      this.numeroRdtSelecionado = numeroRdt;
      await this.consultaNotasRdt(idRdt);
    },
    async openDialogCancelarRdt(idRdt, numeroRdt) {
      this.idRdtSelecionado = idRdt;
      this.protocolo = null;
      this.observacao = null;
      this.numeroRdtSelecionado = numeroRdt;
      this.showCancelarRdt = true;
    },
    async openDialogProtocoloRdt(idRdt, numeroRdt) {
      this.idRdtSelecionado = idRdt;
      this.numeroRdtSelecionado = numeroRdt;
      await this.consultaProtocoloEdicao(idRdt);
    },
    async consultaProtocoloEdicao(idRdt) {
      this.notasProtocoloRdList = [];
      this.showProtocoloEdicao = false;
      this.protocoloSelecionado = null;
      this.processando(true);

      const response = await RdtGerenciador.buscarProtocoloEdicao(idRdt);

      this.protocoloSelecionado = response.data;

      if (this.protocoloSelecionado && this.protocoloSelecionado.id) {
        const notasResponse = await RdtGerenciador.findAllNotasProtocolo(response.data.id);
        this.notasProtocoloRdList = notasResponse;

        this.showProtocoloEdicao = true;
      } else {
        this.$root.$emit(
          "alert:warn",
          "Este RDT não possui protocolo de Edição!"
        );
      }
      this.processando(false);
    },
    async consultaNotasRdt(idRdt) {
      this.notasRdList = [];
      this.processando(true);

      RdtGerenciador.findAllNotasRdt(
        idRdt,
      )
        .then((response) => {
          this.notasRdList = response;
        })
        .then(() => {
          this.processando(false);
          this.showNotasRdt = true;
        });
    },
    async consultaDeclaracoes(idRdt) {
      this.declaracoesList = [];
      this.processando(true);

      RdtGerenciador.findAllDeclaracoes(
        idRdt,
      )
        .then((response) => {
          this.declaracoesList = response;
          console.log(this.declaracoesList);
        })
        .then(() => {
          this.processando(false);
          this.showDeclaracoes = true;
        });
    },

    impressaoConsultaRdt(id) {
      this.processando(true);
      ReportService.imprimir("ConsultaRdt", [
        {
          param: "ID",
          string: id,
        }
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit(
              "alert:warn",
              "Erro ao imprimir RDT!"
            );
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    impressaoNota(rdtNota) {
      if (rdtNota && rdtNota.idNotaFiscal) {

        let nomeRel = "NotaFiscalEletronicaObs";
        ReportService.imprimir(nomeRel, [
          {
            param: "where",
            string: " and nota_fiscal.id = '" + rdtNota.idNotaFiscal + "' ",
          },
        ])
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        ReportService.imprimir("NotaFiscalAuxiliar", [
          {
            param: "where",
            string: " and nota.id = '" + rdtNota.idDaps + "' ",
          },
        ])
          .then(
            () => { },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    impressaoRdt(id, numeroRdt, tipo) {
      this.processando(true);
      ReportService.imprimir("DeclaracaoMensalServicos", [
        {
          param: "ID",
          string: id,
        },
        {
          param: "TIPO",
          string: tipo,
        },
        {
          param: "RDT",
          string: numeroRdt,
        }
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit(
              "alert:warn",
              "Erro ao imprimir Declarações RDT!"
            );
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    async openImpressaoBoleto(idRdt) {
      this.idRdtSelecionado = idRdt;
      this.dataVencimento = null;

      await this.buscarVencimentoAtual(idRdt);
    },
    async buscarVencimentoAtual(idRdt) {
      this.idCalculoOrigem = null;
      this.idCalculoParcelado = null;
      this.processando(true);
      RdtGerenciador.buscarVencimentoAtual(
        idRdt,
      )
        .then((response) => {
          let ret = response.data;
          this.idCalculoOrigem = ret.idCalculoOrigem;
          this.idCalculoParcelado = ret.id;
          this.dataVencimento = ret.dataVencimento;
          if (typeof this.dataVencimento === "string") {
            this.dataVencimento = this.converterData(this.dataVencimento);

          }

        },
          (error) => {
            this.$root.$emit(
              "alert:error",
              error.response.data
            );
          })
        .then(() => {
          this.processando(false);
          this.showBoleto = true;
        });
    },
    async atualizarVencimento() {
      if (this.idCalculoParcelado && this.idCalculoOrigem) {
        this.processando(true);
        await GpiService.atualizarVencimento(
          this.currentUser.usuario.idCliente,
          this.currentUser.usuario.idUsuario,
          this.idCalculoOrigem,
          this.idCalculoParcelado,
          this.dataVencimento
        )
          .then((response) => {
            this.idCalculoParcelado = response.data;
          },
            (error) => {
              this.$root.$emit(
                "alert:error",
                error.data
              );
            })
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", "Não foi possível realizar a impressão contate o administrador do sistema!");
      }
    },
    async imprimirBoleto() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      var novaData = new Date();

      if (novaData > this.dataVencimento) {
        this.dataVencimento = novaData;
      }
      await this.atualizarVencimento();
      await this.imprimirBoletoExecucao();

    },
    async imprimirBoletoExecucao() {
      this.processando(true);
      await GpiService.imprimir(this.currentUser.usuario.idCliente, this.idCalculoParcelado).then(
        (data) => {
          console.log(data);
        },
        (error) => {
          this.$root.$emit(
            "alert:warn",
            "Erro ao exibir a visualização!"
          );
          console.log(error);
        }
      ).then(() => {
        this.processando(false);
      });
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },

    formatted_string(pad, user_str, pad_pos) {
      if (typeof user_str === 'undefined') return pad;
      if (pad_pos == 'l') {
        return (pad + user_str).slice(-pad.length);
      } else {
        return (user_str + pad).substring(0, pad.length);
      }
    },

    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    vencimentoSelect() {
      let dateSelect = this.dataVencimento;
      if (dateSelect) {
        dateSelect.setHours(8);
      }
    },
    converterData(dataString) {
      // Divide a string nos componentes dia, mês e ano
      var partes = dataString.split('/');
      var dia = parseInt(partes[0], 10);
      var mes = parseInt(partes[1], 10) - 1; // Subtrai 1 porque os meses em JavaScript são base 0 (janeiro é 0)
      var ano = parseInt(partes[2], 10);

      // Cria um objeto Date com os componentes
      var data = new Date(ano, mes, dia);

      return data;
    }
  },
};
</script>

<style lang="scss" scoped>
.white-line {
  color: white;
}

/deep/ .green-row {
  background-color: #28a745 !important;
}

/deep/ .red-row {
  background-color: #fd7272 !important;
}
</style>
